module.exports = __webpack_public_path__ + "img/date.932e9be0.svg";